<app-modal class="modal width" [info]="info" (closeModal)="closeModal()" (onSubmit)="onSubmit()">
  @if (state === 'settings') {
    <form [formGroup]="ldDataForm" class="account-form">
      <div class="account-form__item">
        <h4 class="label">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.LOGIN' | translate }}
        </h4>
        <input
          [placeholder]="
            'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.LOGIN_PLACEHOLDER' | translate
          "
          type="text"
          formControlName="login"
          class="account-form__input" />
        @if (ldDataForm.get('login')?.invalid && ldDataForm.get('login')?.touched) {
          <p class="error">
            {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.LOGIN_INVALID_ERROR' | translate }}
          </p>
        }
      </div>
      <div class="account-form__item">
        <h4 class="label">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.PASSWORD' | translate }}
        </h4>
        <input
          [placeholder]="
            'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.PASSWORD_PLACEHOLDER' | translate
          "
          [type]="showPasswordEye && passwordEyeToggled ? 'text' : 'password'"
          class="account-form__input"
          formControlName="password" />
        <i
          class="account-form__eye"
          [class.show]="showPasswordEye"
          [class.active]="passwordEyeToggled"
          (click)="passwordEyeToggled = !passwordEyeToggled"></i>
      </div>
      <div class="account-form__item">
        <h4 class="label">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.COUNTRY' | translate }}
        </h4>
        <app-input-search-selection
          [placeholder]="'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.COUNTRY_PLACEHOLDER'"
          formControlName="country"
          [options]="geoListSelection"
          [selectionDropdownInfo]="selectionDropdownInfo"></app-input-search-selection>
      </div>
    </form>
  }
  @if (state === 'waiting') {
    <div class="loading">
      <app-waiting-animation state="loading" [customLoader]="true">
        <ng-template #customLoaderTemplate>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none">
            <path
              d="M29.1828 67.9911C24.8503 67.2271 20.7108 65.6173 17.0005 63.2536C13.2901 60.8899 10.0817 57.8185 7.55841 54.2148C5.03508 50.6111 3.24626 46.5457 2.29408 42.2507C1.3419 37.9557 1.24501 33.5152 2.00894 29.1828C2.77287 24.8503 4.38266 20.7108 6.74639 17.0005C9.11012 13.2901 12.1815 10.0817 15.7852 7.5584C19.3889 5.03508 23.4543 3.24626 27.7493 2.29408C32.0443 1.3419 36.4848 1.24501 40.8172 2.00894C45.1497 2.77287 49.2892 4.38266 52.9995 6.74639C56.7099 9.11012 59.9183 12.1815 62.4416 15.7852C64.9649 19.3889 66.7537 23.4543 67.7059 27.7493C68.6581 32.0443 68.755 36.4848 67.9911 40.8172C67.2271 45.1497 65.6173 49.2892 63.2536 52.9995C60.8899 56.7099 57.8185 59.9183 54.2148 62.4416C50.6111 64.9649 46.5457 66.7537 42.2507 67.7059C37.9557 68.6581 33.5152 68.755 29.1828 67.9911L29.1828 67.9911Z"
              stroke="#E0E6FF"
              stroke-width="3" />
            <path
              d="M1.5 35C1.5 30.6007 2.3665 26.2445 4.05004 22.1801C5.73357 18.1157 8.20117 14.4227 11.3119 11.3119C14.4227 8.20115 18.1157 5.73356 22.1801 4.05003C26.2445 2.3665 30.6007 1.5 35 1.5"
              stroke="#717BDA"
              stroke-width="3" />
          </svg>
        </ng-template>
      </app-waiting-animation>
      <p class="status-label">
        {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.STATUS_LABELS.WAITING' | translate }}
      </p>
      <p class="info-text">
        {{ textForWaiting[textIndex] | translate }}
      </p>
    </div>
  }
  @if (state === 'in-app-approval') {
    <div class="loading">
      <app-waiting-animation state="loading" [customLoader]="true">
        <ng-template #customLoaderTemplate>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0 0 70 70"
            fill="none">
            <path
              d="M29.1828 67.9911C24.8503 67.2271 20.7108 65.6173 17.0005 63.2536C13.2901 60.8899 10.0817 57.8185 7.55841 54.2148C5.03508 50.6111 3.24626 46.5457 2.29408 42.2507C1.3419 37.9557 1.24501 33.5152 2.00894 29.1828C2.77287 24.8503 4.38266 20.7108 6.74639 17.0005C9.11012 13.2901 12.1815 10.0817 15.7852 7.5584C19.3889 5.03508 23.4543 3.24626 27.7493 2.29408C32.0443 1.3419 36.4848 1.24501 40.8172 2.00894C45.1497 2.77287 49.2892 4.38266 52.9995 6.74639C56.7099 9.11012 59.9183 12.1815 62.4416 15.7852C64.9649 19.3889 66.7537 23.4543 67.7059 27.7493C68.6581 32.0443 68.755 36.4848 67.9911 40.8172C67.2271 45.1497 65.6173 49.2892 63.2536 52.9995C60.8899 56.7099 57.8185 59.9183 54.2148 62.4416C50.6111 64.9649 46.5457 66.7537 42.2507 67.7059C37.9557 68.6581 33.5152 68.755 29.1828 67.9911L29.1828 67.9911Z"
              stroke="#E0E6FF"
              stroke-width="3" />
            <path
              d="M1.5 35C1.5 30.6007 2.3665 26.2445 4.05004 22.1801C5.73357 18.1157 8.20117 14.4227 11.3119 11.3119C14.4227 8.20115 18.1157 5.73356 22.1801 4.05003C26.2445 2.3665 30.6007 1.5 35 1.5"
              stroke="#717BDA"
              stroke-width="3" />
          </svg>
        </ng-template>
      </app-waiting-animation>
      <p class="status-label">
        {{
          'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.STATUS_LABELS.IN_APP_APPROVAL' | translate
        }}
      </p>
      <p class="info-text">
        {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.IN_APP_APPROVAL_INFO_TEXT' | translate }}
      </p>
    </div>
  }
  @if (state === 'error' || state === 'unsupported-action') {
    <div class="error">
      <app-waiting-animation state="error"></app-waiting-animation>
      <p class="status-label">
        {{
          (state === 'unsupported-action'
            ? 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.STATUS_LABELS.UNSUPPORTED_ACTION'
            : 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.STATUS_LABELS.ERROR'
          ) | translate
        }}
      </p>
      <p class="info-text">
        {{
          (state === 'unsupported-action'
            ? 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.UNSUPPORTED_ACTION_INFO_TEXT'
            : 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.ERROR_INFO_TEXT'
          ) | translate
        }}
      </p>
      <ng-template #customActionBtnContent>
        <button (click)="changeStateAndModalInfo('settings')" class="btn modal-btn custom-btn">
          <span class="btn__text">
            {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.BUTTONS_LABELS.RETRY' | translate }}
          </span>
        </button>
      </ng-template>
    </div>
  }
  @if (state === 'success') {
    <div class="success">
      <app-waiting-animation state="success"></app-waiting-animation>
      <p class="status-label">
        {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.STATUS_LABELS.SUCCESS' | translate }}
      </p>
      <p class="info-text">
        {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.SUCCESS_INFO_TEXT' | translate }}
      </p>
      <ng-template #customActionBtnContent>
        <button (click)="closeModal()" class="btn modal-btn custom-btn">
          <span class="btn__text">
            {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.BUTTONS_LABELS.CLOSE' | translate }}
          </span>
        </button>
      </ng-template>
    </div>
  }
  @if (state === 'code' || state === 'code-invalid') {
    <form class="code" [formGroup]="pinCodeForm">
      <p class="bold-title">
        {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.STATUS_LABELS.CODE_TITLE' | translate }}
      </p>
      <app-pin-code-inputs
        formControlName="pinCode"
        [inputsAmount]="INPUT_PIN_AMOUNT"></app-pin-code-inputs>
      @if (state === 'code-invalid') {
        <p class="error-text">
          {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.INVALID_CODE_ERROR' | translate }}
        </p>
      }
      <p class="status-label fixed-width" [class.no-margin]="state === 'code-invalid'">
        {{ codeDescriptionKey | translate }}
      </p>
      <ng-template #customActionBtnContent>
        <button
          (click)="sendCodeForLogin()"
          class="btn modal-btn custom-btn btn--new-primary bright"
          [disabled]="codeBtnDisabled">
          <span class="btn__text">
            {{ 'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.BUTTONS_LABELS.CONNECT' | translate }}
          </span>
        </button>
        <!-- TODO: re-enable once backend contract for resend/try-another-way is confirmed on this env
        <div class="code-secondary-actions">
          <button
            type="button"
            (click)="resendCode()"
            class="text-btn"
            [disabled]="resendCodeDisabled">
            {{
              'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.BUTTONS_LABELS.RESEND_CODE' | translate
            }}
          </button>
          <button
            type="button"
            (click)="tryAnotherWay()"
            class="text-btn"
            [disabled]="tryAnotherWayDisabled">
            {{
              'CAMPAIGN.ACCOUNTS.LINKEDIN_ACCOUNTS.ADD_MODAL.BUTTONS_LABELS.TRY_ANOTHER_WAY'
                | translate
            }}
          </button>
        </div>
        -->
      </ng-template>
    </form>
  }
</app-modal>
